import { Component, Output, EventEmitter } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent {
  navOpen = false;
  @Output() navOpenChange = new EventEmitter<boolean>();

  constructor(private authService: AuthService, private router: Router) {}

  toggleNav() {
    this.navOpen = !this.navOpen;
    this.navOpenChange.emit(this.navOpen);
  }

  logout() {
    this.authService.logoutAndRedirect();
  }
}
